import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { useModal } from '@atlaskit/modal-dialog';
import { Inline } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	wrap: {
		flexWrap: 'wrap-reverse',
	},
});

export interface ModalFooterProps {
	/**
	 * Children of modal dialog footer.
	 */
	children?: ReactNode;

	/**
	 * A `testId` prop is provided for specified elements,
	 * which is a unique string that appears as a data attribute `data-testid` in the rendered code,
	 * serving as a hook for automated tests.
	 */
	testId?: string;
}

export const ModalFooter = (props: ModalFooterProps): React.JSX.Element => {
	const { children, testId: userDefinedTestId } = props;
	const { testId: modalTestId } = useModal();

	const testId = userDefinedTestId || (modalTestId && `${modalTestId}--footer`);

	return (
		<Inline alignInline="end" testId={testId} space="space.150" xcss={styles.wrap}>
			{children}
		</Inline>
	);
};
